// extracted by mini-css-extract-plugin
export default {"mainCont":"LoadNewDkp_mainCont__g0C-e","dtCont":"LoadNewDkp_dtCont__Z-epD"};